import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * quiz endpoints
 */
export const fetchQuizs = ({q, page, perPage, sortOpts, extraParams}, signal) =>
  request.fetchListEnhanced({url: '/quiz', q, page, perPage, sortOpts, extraParams}, signal);

export const fetchAllQuizs = () =>
  request.fetchList('/quiz', undefined, undefined, undefined, {sortField: 'reading_nights', sortDir: 'asc'});

export const fetchQuiz = (quizId) => request.fetchDetail(`/quiz/${quizId}`);

export const createQuiz = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    title: payload.title,
    level: payload.level,
    reading_nights: payload.readingNights,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.postForm('/quiz', formData);
};

export const updateQuiz = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    title: payload.title,
    level: payload.level,
    reading_nights: payload.readingNights,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm(`/quiz/${payload.id}`, formData);
};

export const deleteQuiz = (awardId) => request.deleteReq(`/quiz/${awardId}`);

export const fetchReaderQuizResult = (readerId, q, page, sortOpts, extraParams) =>
  request.fetchList('/reader-quiz-result', q, page, 100, sortOpts, {readerId, ...extraParams});
